import { ModuleName } from '../types/api'

export const modulesLink = {
  orders: 'ORDERS',
  clients: 'CLIENTS',
  'knowledge-base': 'WIKI',
  analytics: 'ANALYTICS',
  support: 'CLIENT_SUPPORT',
  'access-manage': 'CRM_USER',
  logs: 'LOGS',
} as { [key in string]: ModuleName }
